<div class="pt-8 m-auto w-full m-8 w-full" v-if="loaded">
  <details open id="filters" class="sticky top-0 text-sm left-0 bg-white p-2 w-full z-10 shadow-md">
    <summary class="cursor-pointer">Filters</summary>
    <div class="flex">
      <div>
        <div>
          <label> Show checked items: <input type="checkbox" v-model="show_checked"> </label>
        </div>
        <div>
          <label> Show hearts and lightbulbs: <input type="checkbox" v-model="show_heart_lightbulb"> </label>
        </div>
        <div>
          <label> Show icons: <input type="checkbox" v-model="show_icons"> </label>
        </div>
        <div>
          <label>
            Only show feedback after:
            <input type="date" v-model="filter_date" class="border border-gray-300 rounded px-2">
          </label>
          <label class="ml-2">
            <input type="checkbox" v-model="use_date_filter">
            Apply date filter
          </label>
        </div>
      </div>

      <div class="grid grid-flow-col grid-rows-4 grid-cols-7 gap-1 text-xs pl-8">
        <div v-for="(page, index) in pages" :key="index" @click="scrollToPage(page.zine_page)"
             class="cursor-pointer hover:bg-gray-100 px-1 rounded truncate h-5 flex items-center border border-gray-200">
          <span class="font-mono">{{ index + 1 }}</span>
          <span class="ml-1 truncate">{{ page.zine_page.substring(0,12) }}</span>
        </div>
      </div>

    </div>
  </details>

  <div class="relative bg-gray-200 p-8 mt-4 w-full" 
       v-for="page, index in pages"
       :id="page.zine_page"
   >
       <AdminPage 
       :page_hash="page.id"
       :show_checked="show_checked"
       :show_icons="show_icons"
       :show_heart_lightbulb="show_heart_lightbulb"
       :filter_date="filter_date"
       :use_date_filter="use_date_filter"
       :feedbacks="feedback_by_page[page.zine_page]"
       :zine_id="zine_id"
       :people="people"
       :number="index + 1"
       :id="page.zine_page"
       />
  </div>
  <div class="relative bg-gray-200 p-8 mt-4 w-full">
    <div class="w-3/4 m-auto">
      <h2 class='text-3xl text-center mb-8'> Overall Feedback </h2>
      <div v-for="feedback in feedback_by_page['overall']">
        <AdminFeedback v-bind:feedback="feedback" v-bind:person="person(feedback)" />
      </div>
    </div>
  </div>
</div>
